<template>
  <div class="section">
    <h2 style="margin-bottom: 20px">Assets used in this website are attributed below:</h2>
    <p>
      <a target="_blank" href="https://icons8.de/icon/104/stern">Stern</a> Icon von <a target="_blank" href="https://icons8.de">Icons8</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "Attributions"
}
</script>

<style scoped>
  a {
    color: blue;
  }
</style>
